import { PricePlanId, PricePlanType } from '@systemeio/types'
import { PRICE_PLANS_API } from 'modules/digital-product/price-plans/api/price-plans-api'
import {
  PricePlanCreateApiInterface,
  PricePlanEditInterface,
} from 'modules/digital-product/price-plans/types/price-plan-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const usePricePlansApi = () => {
  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post, PricePlanType>({
    method: RequestMethodsEnum.post,
  })
  const { fetcher: putFetcher } = useFetch<RequestMethodsEnum.put, PricePlanType>({
    method: RequestMethodsEnum.put,
  })

  const { fetcher: deleteFetcher } = useFetch<RequestMethodsEnum.delete>({
    method: RequestMethodsEnum.delete,
  })

  return {
    createPricePlan: (data: PricePlanCreateApiInterface) =>
      postFetcher(`${PRICE_PLANS_API}/create`, data),

    updatePricePlan: (id: PricePlanId, data: PricePlanEditInterface) =>
      putFetcher(`${PRICE_PLANS_API}/${id}`, data),

    deletePricePlan: (id: PricePlanId) => deleteFetcher(`${PRICE_PLANS_API}/${id}`),
  }
}
